import organisationsAPI from '@/api/organisations';
import profilesAPI from '@/api/profiles';
import AnalyticsDashboard from '@/components/Analytics/AnalyticsDashboard';
import Layout from '@/components/Layout';
import useAuth from '@/hooks/useAuth';

function AnalyticsPage() {
  const { orgID } = useAuth();

  return (
    <Layout pageName="Analytics" className="bg-gray-100">
      <AnalyticsDashboard
        listProfiles={({ search }) =>
          profilesAPI.listProfiles({ search, orgID })
        }
        listGroups={({ search }) =>
          organisationsAPI.listOrganisationGroups({ search, orgID })
        }
      />
    </Layout>
  );
}

export default AnalyticsPage;
